import axios from 'axios';
import { DEFAULT_API_CONFIG } from './apiConfig';

const api = axios.create({
  baseURL: DEFAULT_API_CONFIG.url,
  timeout: DEFAULT_API_CONFIG.timeout,
  headers: DEFAULT_API_CONFIG.getHeaders()
});

export const getActiveCallList = async () => {
  const response = await api.get('/calls/active');
  return response.data;
};

export const terminateCall = async (callId) => {
  const response = await api.post(`/calls/${callId}/terminate`);
  return response.data;
};

export const getCallStatus = async (callId) => {
  const response = await api.get(`/calls/${callId}/status`);
  return response.data;
}; 